
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { DataType } from "@dndModels/Types";
import { 
  Feature,
  FeatureBase,
  // Limitation 
} from "@models";

export class FightingStyle extends DandDFeatureSource {
  data_type: DataType = "fighting_style";
  feature_source_type = "FightingStyle";
  // feature_bases: Feature[] = [];

  constructor(obj?: any) {
    super(obj, "FightingStyle");
    if (obj) {
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        // const common_util = DataUtilities.getInstance();
        const features: Feature[] = [];
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature = new Feature(o);
          features.push(feature);
        });
        const feature_base = new FeatureBase();
        feature_base.feature_source_id = this._id;
        feature_base.feature_source_type = this.feature_source_type;
        feature_base.features = features;
        this.feature_bases.push(feature_base);
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       // const common_util = DataUtilities.getInstance();
  //       const features: Feature[] = [];
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature = new Feature(o);
  //         features.push(feature);
  //       });
  //       const feature_base = new FeatureBase();
  //       feature_base.feature_source_id = this._id;
  //       feature_base.feature_source_type = this.feature_source_type;
  //       feature_base.features = features;
  //       this.feature_bases.push(feature_base);
  //     }
  //   }
  // }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
    };
  }

  copy(copyMe: FightingStyle, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
  }

  clone(drop_ids = false): FightingStyle {
    const new_obj = new FightingStyle();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy5e(copyMe: any): void {
    this.name = copyMe.name.substring(21);
    this.description = "";
    copyMe.desc.forEach((d: any) => {
      this.description += d + "\n ";
    });
  }
}